export default __webpack_public_path__ + "static/media/pipe.6fd335b8.svg";